<form [formGroup]="releaseGroup" (ngSubmit)="onSubmit()" [ngClass]="{'view-mode': mode=='View'}">
    <div class="title-outer">
        <h2 class="form-title" *ngIf="mode=='New'">{{ languageService.languageJSON.ReleaseDetails_Title }}</h2>
        <h2 class="form-title" *ngIf="mode=='View'">{{ languageService.languageJSON.ReleaseDetails_View_Title }}</h2>
        <h2 class="form-title" *ngIf="mode=='Edit'">{{ languageService.languageJSON.ReleaseDetails_Edit_Title }}</h2>
    </div>

    <app-loading-animation class="edit-animation" *ngIf="loading"></app-loading-animation>

    <div class="form-section-function" [hidden]="!softwareModifyRole || loading || (mode!='View' )"
        *ngIf="!noDataError">
        <div class="flex-col">
            <div class="flex-row">
                <div class="row-to-right">
                    <button *ngIf="mode=='View' && rolloutStatus==1" type="button" class="button-with-icon"
                        (click)="editRelease()"><img src="assets/icons/edit.svg" /> {{
                        languageService.languageJSON.Global_Edit }}</button>
                    <button [ngClass]="{'inactive-with-popup': releaseDeleteInactive }"
                        [matTooltip]="releaseDeleteInactive ? languageService.languageJSON.ReleaseOverview_DeleteInactive: ''"
                        matTooltipClass="configtool-tooltip" type="button" class="button-with-icon"
                        (click)="deleteRelease()"><img src="assets/icons/delete.svg" /> {{
                        languageService.languageJSON.Global_Delete }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="!noDataError">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row" *ngIf="releaseId && mode=='View'">
                    <label>ID:</label>
                    <label>{{ releaseId }}</label>
                </div>

                <div class="flex-row">
                    <label required>{{ languageService.languageJSON.ReleaseDetails_Version }}:</label>
                    <label *ngIf="mode=='View'">{{version?.value}}</label>
                    <input *ngIf="mode!='View'" type="text" name="version" formControlName="version">
                </div>

                <div class="flex-row" *ngIf="version?.invalid && version?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_Version }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                        {{ languageService.languageJSON.ReleaseDetails_Release_Requirement }}
                    </h5>
                </div>

                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_ReleaseNotes }}:</label>

                    <textarea *ngIf="mode=='New' || mode=='Edit'" name="releaseNote"
                        formControlName="releaseNote"></textarea>

                    <div class="value" *ngIf="mode=='View'">
                        <span *ngIf="!editReleaseNotes">
                            {{ releaseNote?.value }}
                            <img *ngIf="softwareModifyRole" (click)="editReleaseNotes=true" class="edit-field"
                                src="assets/icons/edit.svg" />
                        </span>

                        <textarea *ngIf="softwareModifyRole && editReleaseNotes==true" name="releaseNote"
                            formControlName="releaseNote" [ngClass]="{'edit-mode': editReleaseNotes}"></textarea>

                        <span *ngIf="softwareModifyRole && editReleaseNotes" class="approval-edit">
                            <button (click)="saveReleaseChanges()">
                                {{ languageService.languageJSON.Global_Save }}</button>
                        </span>
                    </div>
                </div>

                <div class="flex-row" *ngIf="mode=='View'">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_CreationDate }}:</label>
                    <div class="value">
                        {{ uploadDate | date:'long' }}
                    </div>
                </div>

                <div class="flex-row" *ngIf="mode=='View'">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_CreatedBy }}:</label>
                    <div class="value">
                        {{ uploadUser }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="!noDataError">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label required>{{ languageService.languageJSON.ConfigurationDetails_OE }}:</label>
                    <mat-select required *ngIf="oeOptionsList" formControlName="oem"
                        (selectionChange)="updateComponentList()">
                        <mat-option *ngFor="let oe of oeOptionsList" [value]="oe.id">{{ oe.name }}</mat-option>
                    </mat-select>
                </div>

                <div class="flex-row" *ngIf="oem?.invalid && oem?.touched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ConfigurationDetails_OE }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>

                <div class="flex-row double-selector-row" [hidden]="oem?.value==''">
                    <label required>{{ languageService.languageJSON.ReleaseDetails_TargetBikeComponent }}:</label>
                    <div class="flex-col">
                        <div class="flex-row">
                            <mat-select required *ngIf="componentClassOptionsList" formControlName="componentClass"
                                (selectionChange)="updateComponentList()">
                                <mat-option *ngFor="let componentClassOption of componentClassOptionsList"
                                    [value]="componentClassOption.id" selected>{{ componentClassOption.name
                                    }}</mat-option>
                            </mat-select>
                        </div>
                        <div class="double-selector">
                            <mat-select required *ngIf="componentList.length>0" formControlName="component">
                                <mat-option *ngFor="let componentEl of componentList" [value]="componentEl"
                                    [attr.tenant]="componentEl.OEMName" selected>{{
                                    componentEl.ComponentName }}</mat-option>
                            </mat-select>
                            <mat-select required formControlName="componentVariant">
                                <mat-option *ngFor="let variantEl of component?.value?.Variants" [value]="variantEl.Id"
                                    [attr.tenant]="variantEl.OEMName" selected>{{variantEl.Name }}</mat-option>
                            </mat-select>
                            <label *ngIf="componentList.length==0">{{
                                languageService.languageJSON.ConfigurationDetails_NoOption }}</label>
                        </div>
                    </div>

                </div>

                <div class="flex-row" *ngIf="component?.invalid && component?.touched" [hidden]="oem?.value==''">
                    <h5 class="error">
                        {{ languageService.languageJSON.ReleaseDetails_TargetBikeComponent }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="!noDataError && (mode=='New' || mode=='Edit')">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <div class="upload-outer">
                        <div class="upload-file" *ngIf="!hexFileName">
                            <label for="firmware-upload" name="avatar_btn" class="upload-file-text" appDnd
                                (fileDropped)="onFileDropped($event)">
                                <img class="dnd-icon" src="assets/icons/drop-here.svg" />
                                <span>{{ languageService.languageJSON.ConfigurationAssignBikes_ChooseOrDnd }}</span>
                            </label>
                            <input style="display: none;" name="firmware-upload" type="file" id="firmware-upload"
                                (change)="fwUpload($event)" accept=".hex" />
                        </div>
                        <div class="upload-file" *ngIf="hexFileName">
                            <div class="clear-icon" *ngIf="mode=='New'" (click)="clearHexFile()">×</div>
                            <label class="hex-name">{{ hexFileName }}</label>
                        </div>
                        <p class="red" *ngIf="invalidFile">{{
                            languageService.languageJSON.ReleaseDetails_InvalidFileFormat }}</p>
                        <p *ngIf="invalidFile">{{ languageService.languageJSON.ReleaseDetails_NamingRequirements }}</p>
                        <p *ngIf="invalidFile">{{ languageService.languageJSON.ReleaseDetails_NamingExample }}</p>
                        <p class="red" *ngIf="fileTooLarge">{{
                            languageService.languageJSON.ReleaseDetails_ErrorCode_TooLargeFile }}</p>
                    </div>
                </div>
                <div class="flex-row" *ngIf="!hexFileName && hexFileTouched">
                    <h5 class="error">
                        {{ languageService.languageJSON.ReleaseDetails_HexFile }}
                        {{ languageService.languageJSON.Form_Required_Error }}
                    </h5>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="!noDataError && mode=='View'">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ManageBikes_Filename }}:</label>
                    <div class="form-row-description">
                        {{ hexFileName }} <span *ngIf="activationStatus==2">(<a (click)="downloadFirmware()">Download</a>)</span> 
                    </div>
                </div>
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_Checksum }}:</label>
                    <label *ngIf="mode=='View'">{{hexFileSHA}}</label>
                    <input *ngIf="mode!='View'" [value]="hexFileSHA">
                </div>
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_Size }}:</label>
                    <label *ngIf="mode=='View'">{{hexFileSize}}</label>
                    <input *ngIf="mode!='View'" [value]="hexFileSize">
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="!noDataError && mode=='View'">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_ActivationStatus }}:</label>
                    <label *ngIf="mode=='View'">{{utilsService.getActivationState(activationStatus)}}</label>
                    <input *ngIf="mode!='View'" [value]="utilsService.getActivationState(activationStatus)">
                </div>
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_ApprovalStatus }}:</label>
                    <label *ngIf="mode=='View'">{{utilsService.getApprovalState(approvalStatus)}}</label>
                    <input *ngIf="mode!='View'" [value]="utilsService.getApprovalState(approvalStatus)">
                </div>
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_RolloutStatus }}:</label>
                    <label *ngIf="mode=='View'">{{utilsService.getRolloutState(rolloutStatus)}}</label>
                    <input *ngIf="mode!='View'" [value]="utilsService.getRolloutState(rolloutStatus)">
                </div>
            </div>
        </div>
    </div>

    <div class="form-section table" [hidden]="loading" *ngIf="!noDataError && mode=='View'">
        <div class="rule-title">{{ languageService.languageJSON.ReleaseDetails_Logbook }}</div>
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_Date }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_User }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_Action }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_Details }}
                </div>
            </div>
            <div>
                <div class="flex-row" *ngFor="let logbookElement of logbook; let index=index">
                    <div class="flex-col">
                        {{ logbookElement.Date | date : 'long' }}
                    </div>
                    <div class="flex-col">
                        {{ logbookElement.UserId }}
                    </div>
                    <div class="flex-col">
                        {{ logbookElement.Action }}
                    </div>
                    <div class="flex-col">
                        {{ logbookElement.Details }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="noDataError">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label class="error-label">{{ languageService.languageJSON.ReleaseDetails_ErrorCode_E029 }}</label>
                </div>
            </div>
        </div>
    </div>

    <h5 class="red error bottom-error" [hidden]="loading" *ngIf="backendError">
        {{ backendError }}</h5>

    <div class="form-section-send" [hidden]="loading" *ngIf="!noDataError && mode!='View'">
        <button type="submit">
            <span *ngIf="mode=='New'">{{ languageService.languageJSON.ReleaseDetails_Upload}}</span>
            <span *ngIf="mode=='Edit'">{{ languageService.languageJSON.Global_Save}}</span>
        </button>
        <button class="back-button" (click)="goBack()">{{ languageService.languageJSON.Global_Cancel}}</button>
    </div>
</form>